import {Component, OnInit, ViewChild} from '@angular/core';
import {StripeCardComponent, StripeService} from 'ngx-stripe';
import {StripeCardElementOptions, StripeElementsOptions} from '@stripe/stripe-js';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {RequestMethod, RestService} from '../../../../shared/services/rest.service';
import {environment} from '../../../../../environments/environment';
import {Actions, ApiEndpoints} from '../../../../shared/constants/ApiEndpoints';
import {GeneralConstant} from '../../../../shared/constants/GeneralConstant';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ResponseSnackbarService} from '../../../../shared/services/response-snackbar.service';
import {finalize} from 'rxjs/operators';
import {reactiveFormValidator} from '../../../../shared/utils/Reactive-form-validation-trigger';
import {MessageInfo} from '../../../../shared/enums/error-messages/MessageInfo';
import {TooltipService} from '../../../../shared/services/tooltip.service';
import {ConfirmModalComponent} from '../../../shared/modules/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-stripe-add-card',
  templateUrl: './stripe-add-card.component.html',
  styleUrls: ['./stripe-add-card.component.scss']
})
export class StripeAddCardComponent implements OnInit {
  @ViewChild(StripeCardComponent) card: StripeCardComponent;
  // elements: Elements;
  // cardNumber: StripeElement;
  // cardExpiry: StripeElement;
  // cardCvc: StripeElement;
  stripeForm: FormGroup;
  confirmBtnDisabled = false;
  saveBtnLoading = false;
  defaultInvalid = MessageInfo.LIMIT_2_AND_100;
  defaultRequired = MessageInfo.REQUIRED_FIELD;
  defaultExists = MessageInfo.ALREADY_EXISTS;
  invalidEmail = MessageInfo.LIMIT_6_AND_100;
  tooltipService: any;


  /*
  ** Options
   */
  options = {
    style: {
      base: {
        color: '#6d767e',
        fontWeight: 400,
        fontFamily: 'Roboto, sans-serif',
        lineHeight: '40px',
        fontSize: '14px',
        fontSmoothing: 'antialiased',
        '::placeholder': {
          color: '#adb5bd'
        }
      },
      invalid: {
        color: 'red'
      }
    },
  };

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontWeight: '300',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '18px',
        '::placeholder': {
          color: '#CFD7E0'
        }
      }
    }
  };

  /*
  * Element Options
   */
  elementsOptions: StripeElementsOptions = {
    locale: 'en'
  };

  constructor(
    private restService: RestService,
    private stripeService: StripeService,
    public dialogRef: MatDialogRef<StripeAddCardComponent>,
    private snackBar: ResponseSnackbarService,
    private fb: FormBuilder,
    private dialog: MatDialog) {
  }

  ngOnInit() {
    this.initStripeForm();
    // this.initStripeElements();
  }

  cancel() {
    if (this.stripeForm.dirty) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        data: {
          fullName: 'Warning',
          name: '',
          type: 'Confirm',
          removeQuestionMark: true,
          content: 'You have unsaved changes. If you close the pop-up window, these changes will be lost.'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.delete) {
          this.dialogRef.close();
        }
        return;
      });
    } else {
      this.dialogRef.close();
    }
  }

  onSubmit(): void {
    if (!this.stripeForm.valid) {
      reactiveFormValidator(this.stripeForm);
      return;
    }
    this.saveBtnLoading = true;
    this.confirmBtnDisabled = true;
    const name = this.stripeForm.get('name').value;

    this.stripeService
      .createToken(this.card.element, {name})
      .pipe(
        finalize(() => {
          this.saveBtnLoading = false;
        })
      )
      .subscribe(result => {
        this.onCreateToken(result);
      }, error => {
        this.confirmBtnDisabled = false;
      });
  }

  /*
  * Generate Token
   */
  onCreateToken(result): void {
    const URL = `${environment.api}/${environment.apiVersion}/${ApiEndpoints.ACCOUNT.PAYMENT}/${Actions.BASE_ACTIONS.UPDATE}/add_card`;

    if (result.token) {
      this.restService.restRequest(
        RequestMethod.POST,
        URL,
        {
          body: {
            token: result.token.id
          }
        }
      ).subscribe(response => {
        this.confirmBtnDisabled = false;

        // Close modal on success
        this.dialogRef.close();

        const message = response['message'];

        if (response && response['success']) {
          this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_SUCCESS_CLASS);
        } else {
          this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        }
      }, error => {
        const message = error.error.message;
        this.snackBar.onResponseMessage(message, GeneralConstant.SNACKBAR_RES_ERROR_CLASS);
        this.dialogRef.close();
      });
    } else if (result.error) {
      this.confirmBtnDisabled = false;
    }
  }

  /*
  * Init Stripe Form
   */
  private initStripeForm(): void {
    this.stripeForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(255), Validators.pattern(GeneralConstant.NAME_REGEX_VALIDATOR)]]
    });
    this.tooltipService = new TooltipService(this.stripeForm);
  }

  /*
  * Init Stripe Elements
   */
  // private initStripeElements(): void {
  //   this.stripeService.elements(this.elementsOptions)
  //     .subscribe(elements => {
  //       this.elements = elements;
  //
  //       if (!this.cardNumber) {
  //         this.cardNumber = this.elements.create('cardNumber', this.options);
  //         this.cardNumber.mount('#card-number');
  //       }
  //
  //       if (!this.cardExpiry) {
  //         this.cardExpiry = this.elements.create('cardExpiry', this.options);
  //         this.cardExpiry.mount('#card-expiry');
  //       }
  //
  //       if (!this.cardCvc) {
  //         this.cardCvc = this.elements.create('cardCvc', this.options);
  //         this.cardCvc.mount('#card-cvc');
  //       }
  //     });
  // }
}
